import { theme as theme2 } from '@clubspark-react/ui';
import { unstable_createMuiStrictModeTheme as createTheme } from '@mui/material/styles';

import {
  BACKGROUND_GREY,
  DISABLED_AND_BORDERS,
  DIVIDER_GREY,
  ERROR_MAIN,
  MAIN_BACKGROUND_COLOR,
  TEXT_GREY,
  TEXT_GREY_DARK,
  TEXT_MAIN,
  WHITE,
} from 'theme/colors';

import { themeV2 } from './themeV2';

export const breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1920,
};

export const theme = () =>
  createTheme({
    breakpoints: {
      values: breakpoints,
    },
    palette: {
      background: {
        default: MAIN_BACKGROUND_COLOR,
        paper: WHITE,
      },
      primary: {
        main: themeV2.colors.primary100main.value,
        dark: themeV2.colors.primary100main.value,
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#000',
      },
      grey: {
        50: TEXT_GREY_DARK,
        100: TEXT_GREY,
        200: DIVIDER_GREY,
        300: DISABLED_AND_BORDERS,
        400: BACKGROUND_GREY,
      },
      action: {
        disabled: DISABLED_AND_BORDERS,
      },
      error: {
        main: ERROR_MAIN,
      },
    },
    typography: {
      fontFamily: 'var(--fonts-default, "DM Sans")',
      fontSize: 14,
      htmlFontSize: 16,
      h1: {
        fontSize: 16,
        fontWeight: 600,
        marginBottom: 8,
      },
      h3: {
        fontSize: 14,
        fontWeight: 400,
      },
      button: {
        textTransform: 'none',
      },
      allVariants: {
        color: TEXT_MAIN,
      },
    },
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            fontWeight: 900,
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            fontSize: 15,
            lineHeight: 1.5,
            '&$focused': {
              borderColor: themeV2.colors.primary100main.value,
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            fontSize: 15,
            minHeight: '21px',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: DISABLED_AND_BORDERS,
            borderWidth: 1,
          },
          root: {
            '&.Mui-error .MuiOutlinedInput-notchedOutline': {
              borderColor: theme2.colors.destructive100main.value,
            },
          },
        },
      },
      MuiGrid: {
        styleOverrides: {
          'spacing-xs-2': {
            width: 'auto',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          textSizeLarge: {
            padding: '10px 14px',
            lineHeight: 1.6,
            fontSize: 14,
          },
          textPrimary: {
            color: TEXT_MAIN,
            padding: '8px 16px',
            lineHeight: 1.6,
            '&:hover': {
              backgroundColor: BACKGROUND_GREY,
            },
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paperAnchorRight: {
            width: '560px',
            [`@media (max-width: ${breakpoints.sm}px)`]: {
              minWidth: '100%',
              width: '100%',
            },
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            fontFamily: 'var(--fonts-default, "DM Sans")',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            transition: 'none',
          },
        },
      },
    },
  });
